import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { oneLine } from './ReviewCardReviewer.styles';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* The logo's circle, from the design, larger than the preview card's. The theme has no sizing scale. Exported
   because the circle itself is `ReviewCardPartnerLogo`, which is told what size to draw. */
export const LOGO_SIZE = '32px';

export const reply = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
  padding: var(${spacing.md});
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.brand});
`;

export const header = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
`;

/* Takes the space the date does not, so a long partner name truncates rather than
   pushing the date off the row. */
export const partner = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
`;

/* 700 is a literal because the theme has one body weight and no bold step. */
export const partnerName = css`
  ${oneLine}
  font-weight: 700;
  color: var(${colors.content.default});
`;

export const partnerLocation = css`
  ${oneLine}
  color: var(${colors.content.secondary});
`;

export const date = css`
  flex-shrink: 0;
  align-self: flex-start;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  white-space: nowrap;
`;

/* No clamp and no control: the full review shows the whole reply. `overflow-wrap`
   because a reply can be a single unbroken token, a URL for instance, which would
   otherwise run past the card's edge. */
export const text = css`
  margin: 0;
  overflow-wrap: anywhere;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
`;
